import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { COMPANY_ID_OVERRIDE, isCompanyDetailsV2Path, SKIP_COMPANY_ID } from '../http/company-id-context';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.context.get(SKIP_COMPANY_ID)) {
      return next.handle(request.clone({
        headers: request.headers.delete('X-Company-Id')
      }));
    }

    const companyIdOverride = request.context.get(COMPANY_ID_OVERRIDE)?.trim();
    if (companyIdOverride) {
      return next.handle(request.clone({
        headers: request.headers.set('X-Company-Id', companyIdOverride)
      }));
    }

    // Feature-specific API calls may supply the target company explicitly.
    // Preserve that value instead of replacing it with the active company.
    const explicitCompanyId = request.headers.get('X-Company-Id');
    if (explicitCompanyId) {
      return next.handle(request);
    }

    if (this.isCompanyDetailsV2Page()) {
      return next.handle(request.clone({
        headers: request.headers.delete('X-Company-Id')
      }));
    }

    // Получаем значение companyId из localStorage
    const companyId = localStorage.getItem('companyId');

    // Проверяем, что запрос отправляется на нужный домен
    if (!request.url.includes('auth0') && !request.url.includes('owler.com') && !request.url.includes('us-central1') && !request.url.includes('readme.io')) {
      // Сохраняем старые заголовки
      //const oldHeaders = request.headers;

      // Если companyId есть, добавляем заголовок X-Company-Id
      if (companyId) {
        request = request.clone({
          headers: request.headers.set('X-Company-Id', companyId)
        });
      } else {
        // Если companyId отсутствует, удаляем заголовок X-Company-Id
        request = request.clone({
          headers: request.headers.delete('X-Company-Id')
        });
      }

      // Продолжаем обработку запроса
      return next.handle(request).pipe(
        tap(() => {
          // if (companyId) {
          //   // Восстанавливаем старые заголовки
          //   request = request.clone({ headers: oldHeaders });
          //   localStorage.removeItem('companyId');
          // }
        })
      );
    } else {
      // Если запрос отправляется на другой домен, просто продолжаем обработку без добавления заголовка
      return next.handle(request);
    }
  }

  private isCompanyDetailsV2Page(): boolean {
    return typeof window !== 'undefined' && isCompanyDetailsV2Path(window.location.pathname);
  }

}

